<div class="open-widget">
  <div class="header">
    <tabler-icon [name]="headerIcon"></tabler-icon>
    <span>{{headerText}}</span>
  </div>
  <div class="content">
    <span class="open-cards-count">{{text1}}</span>
    <span class="total-cards-count">{{text2}}</span>
  </div>
  <app-progress-bar *ngIf="progressTotal && progressValue != null" [progress]="(progressTotal == 0 && progressValue == 0) ? 0 : (progressValue! / progressTotal!) * 100" [color]="progressColor"></app-progress-bar>
</div>

